var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCcs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "dealer-logo-1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "195 -23 599 133",
    style: {
      display: "inline-block",
      verticalAlign: "middle",
      width: "95%",
      height: "100%"
    },
    xmlSpace: "preserve",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    fill: "#cc1814",
    d: "M441.6,43.7C498,47.1,643.5,38,724.2,60.2c35.2,9.7,51.2,19.3,62.8,43C763.4,7.5,489.6,37.3,441.6,43.7                 L441.6,43.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M274.3,25.8l49.9-7.3l10.2,12.2L274.3,25.8z M254,17.1l-48.6-1.9c-6.1-0.2-3.1,31,1.3,41                 c-1.4,3.8-2.5,7.8-3.2,11.8h10.1c15.9-18.2,32-26.4,52.3-25.9l167.8,2.2c-54.9-6-73.9-9.7-80.2-15.8l-9.4-10.3                 c-6.7-7.2,42.4-14.4,51.3-16.3c63.4-13,119.6,6,189.2,30.5C524-13.2,452.2-29.3,348.7-7.2l-72.4,19.8                 C268,13.7,260.6,15.1,254,17.1L254,17.1z M207.3,54.5c2.1-21.3,14.4-27.5,32-32.2C222.5,30,212.7,41.2,207.3,54.5L207.3,54.5z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCcs);
export default __webpack_public_path__ + "static/media/ccs.2dec42453b41aac87e47ef1c854fd102.svg";
export { ForwardRef as ReactComponent };